import { render } from "./RegisterContract.vue?vue&type=template&id=561a8b56&scoped=true"
import script from "./RegisterContract.js?vue&type=script&lang=js"
export * from "./RegisterContract.js?vue&type=script&lang=js"

import "./RegisterContract.scss?vue&type=style&index=0&id=561a8b56&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561a8b56"]])

export default __exports__